import React from 'react';
import { Search } from 'lucide-react';
import { Input } from './ui/Input';
interface SearchBarProps {
  placeholder?: string;
  className?: string;
}
export function SearchBar({
  placeholder = 'Buscar ayuda...',
  className = ''
}: SearchBarProps) {
  return <div className={`max-w-2xl w-full mx-auto ${className}`} data-id="element-145">
      <div className="relative group" data-id="element-146">
        <Input type="text" placeholder={placeholder} icon={<Search className="h-5 w-5 text-[#0af]" data-id="element-148" />} className="h-14 pl-12 text-lg shadow-lg border-0 ring-offset-transparent focus-visible:ring-[#0af] placeholder:text-gray-400" data-id="element-147" />
      </div>
    </div>;
}